<template>
  <header class="gap-header">
    <action
      v-if="active"
      class="gap-header__navigation gap-header__navigation--previous"
      :class="{ 'is-visible': previousSelectable }"
      :title="$t('previousDay')"
      square
      @click="previousDay"
    >
      <span class="sr-only">{{ $t('previousDay') }}</span>
      <icon type="chevron-left" />
    </action>

    <h3 class="gap-header__title">
      {{ weekday }}, <strong>{{ active ? date.long : date.short }}</strong>
      <small v-if="$store.state.gaps[gapDate]">{{ $store.state.gaps[gapDate]['openingHours'] }} {{ $t('hour') }}</small>
    </h3>

    <action
      v-if="active"
      class="gap-header__navigation gap-header__navigation--next"
      :class="{ 'is-visible': nextSelectable }"
      :title="$t('nextDay')"
      square
      @click="nextDay"
    >
      <span class="sr-only">{{ $t('nextDay') }}</span>
      <icon type="chevron-right" />
    </action>
  </header>
</template>

<script>
import humanDate from '../functions/humanDate'
import dateHelper from '../functions/dateHelper'

import action from './action.vue'
import icon from './icon.vue'

export default {
  name: 'CGapHeader',

  components: {
    action,
    icon
  },

  props: {
    type: {
      type: String,
      required: true
    }
  },

  computed: {
    active () {
      return this.type === 'active'
    },
    weekday () {
      return humanDate(this.$store.state.arrivalTable[this.type].date, this.$i18n.locale).weekday.short
    },
    date () {
      return humanDate(this.$store.state.arrivalTable[this.type].date, this.$i18n.locale).date
    },
    gapDate () {
      return this.$store.state.arrivalTable[this.type].date
    },
    previousSelectable () {
      return this.$store.state.arrivalTable.previous.selectable
    },
    nextSelectable () {
      return (new Date(this.gapDate)) < (new Date(this.$store.state.maxDate))
    }
  },

  methods: {
    previousDay: function () {
      this.$store.dispatch('calculateArrivalDates', { currentDate: dateHelper.dayBefore(this.gapDate) })
    },

    nextDay: function () {
      this.$store.dispatch('calculateArrivalDates', { currentDate: dateHelper.dayAfter(this.gapDate) })
    }
  }
}
</script>

<i18n locale="en">
{
  "previousDay": "Previous Day",
  "nextDay": "Next Day",
  "hour": "h"
}
</i18n>

<i18n locale="de">
{
  "previousDay": "Vorheriger Tag",
  "nextDay": "Nächster Tag",
  "hour": "Uhr"
}
</i18n>

<style lang="scss">
@import "../css/variables";

.gap-header {
  display: flex;
  align-items: center;
  margin-bottom: $gutter-sm;
  padding: $gutter-sm;

  background-color: #fff;
}

.gap-header__navigation {
  flex-shrink: 0;

  visibility: hidden;
  opacity: 0;

  transition:
    visibility 0.2s,
    opacity 0.2s;

  &.is-visible {
    visibility: visible;
    opacity: 1;
  }
}

.gap-header__navigation--previous {
  margin-right: $gutter-xs;
}

.gap-header__navigation--next {
  margin-left: $gutter-xs;
}

.gap-header__title {
  flex-grow: 1;

  font-size: 1.125em;
  font-weight: 500;
  text-align: center;
  text-transform: uppercase;

  small {
    display: block;
    text-transform: none;
  }

  @media (min-width: $breakpoint-md) {
    font-size: 1.1875em;
  }
}
</style>
